import React from 'react'

import OrderActions from '../../actions/OrderActions.js'
import t from 'src/helpers/Languages.js'

import {Alert, Button, Modal, ModalHeader, ModalActions} from '../UI/index.js'
import {formSpacing, FormStack, Input} from '../UI/forms/index.js'

class SendEmailNotificationPopup extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            isOpen: false,
            order: null,
            callback: null,
            email: '',
            loading: false,
            message: '',
            error: '',
            errors: []
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))
    }

    open(order, callback) {
        this.setState({isOpen: true, order, email: order.email, callback})
    }

    close() {
        typeof this.state.callback === 'function' && this.state.order && this.state.callback(this.state.order)
        this.setState(this.initialState)
    }

    send() {
        const {order, email} = this.state

        if (email) {
            this.setState({loading: true, message: '', error: ''})

            OrderActions.sendDeliveryMail(order._id, email, (err, order) => {
                if (err) {
                    this.setState({loading: false, error: err})
                } else {
                    this.setState({order, loading: false, message: t('emailSentTo', email)})
                }
            })
        }
    }

    render() {
        const {isOpen, email, loading, message, error, errors} = this.state

        return (
            <Modal show={isOpen} style={{width: errors.length > 0 ? 800 : 400, maxWidth: '90%'}} onClose={this.close.bind(this)}>
                <ModalHeader title={t('sendProofOfCompletion')} />

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label={t('emailAddress')}
                        value={email}
                        onChange={(event) => this.setState({email: event.target.value})}
                    />
                </FormStack>

                {message &&
                    <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                }

                {error &&
                    <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                }

                {errors.length > 0 && errors.map((error, index) => {
                    return <Alert style={{marginBottom: 6}} key={`error${index}`} variant='danger'>{error}</Alert>
                })}

                <ModalActions>
                    {!message && !error &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            {t('cancel')}
                        </Button>
                    }

                    {!message && !error &&
                        <Button
                            variant='text'
                            loading={loading}
                            onClick={this.send.bind(this)}
                        >
                            {t('confirm')}
                        </Button>
                    }

                    {(message || error) &&
                        <Button
                            variant='text'
                            onClick={this.close.bind(this)}
                        >
                            {t('close')}
                        </Button>
                    }
                </ModalActions>
            </Modal>
        )
    }
}

export default SendEmailNotificationPopup
